//@ts-nocheck
import { makeApiRequest, decryptEnv } from "../helpers";
import loggly_util from "../loggly-util";
import { getConfig } from "../config/config";
const { APP_BASE_API_URL, APP_BASE_SWARAJ_API_URL, APP_OCP_APIM_KEY, APP_HEAD_KEY, APP_HEAD_REQUEST_CODE, APP_USER_ID, APP_PASSWORD, } = getConfig();
export const opt = (data) => {
    const myData = [];
    for (var i = 0; i < data.length; i++) {
        var obj = {};
        obj["symbol"] = data[i].ShortName.trim();
        obj["full_name"] = `${data[i].Exch}:${data[i].Name}/${data[i].ScripCode}/${data[i].ShortName.trim()}/${data[i].ExchType}/${data[i].Instrument}/${data[i].CPType}/${data[i].StrikeRate}/searchTrue`;
        obj["description"] = data[i].FullName;
        obj["exchange"] =
            data[i].Exch == "N" ? "NSE" : data[i].Exch == "B" ? "BSE" : "MCX";
        obj["type"] =
            data[i].Instrument == "INDEX FUT"
                ? "futures"
                : data[i].Instrument == "INDEX OPT"
                    ? "options"
                    : data[i].Instrument == "Commodity"
                        ? "future-curcom"
                        : data[i].Instrument == "FUTSTK"
                            ? "futures"
                            : data[i].Instrument == "FUTCUR"
                                ? "futures"
                                : data[i].Instrument == "OPTCUR"
                                    ? "options"
                                    : data[i].Instrument == "OPTSTK"
                                        ? "options"
                                        : "overview";
        obj["ticker"] = `${data[i].Exch == "N" ? "NSE" : data[i].Exch == "B" ? "BSE" : "MCX"}:${data[i].Name}/${data[i].ScripCode}-${data[i].ExchType}`;
        myData.push(obj);
    }
    return myData;
};
export const callingElasticSearch = async (newInput, currentFilter = "", skip = 0, top = 100) => {
    var _a;
    try {
        const searchRequest = await makeApiRequest(`${APP_BASE_API_URL}tradeapi/elastic-search-v2`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "ocp-apim-subscription-key": decryptEnv(APP_OCP_APIM_KEY),
            },
            body: JSON.stringify({
                search: newInput + "*",
                searchMode: "any",
                filter: currentFilter,
                orderby: "SymbolOrder,SearchOrder,Expiry,StrikeRate,CPType,Turnoverdata desc, MarketCapital desc, FullName",
                select: "Exch,ExchType,ExpiryDate,MarketCapital,ScripCode,CPType,Name,FullName,ShortName,Turnoverdata,Instrument,Series,IndexId",
                searchFields: "DisplayName,Name",
                count: true,
                skip: skip,
                top: top,
            }),
        });
        return (_a = searchRequest.value) !== null && _a !== void 0 ? _a : [];
    }
    catch (e) {
        loggly_util.logAdvancedMessage(e, {
            error: e.message,
            APIURL: `${APP_BASE_API_URL}tradeapi/elastic-search-v2`,
            Windowurl: window.location.href,
            Token: JSON.parse(localStorage.TokenResponseTv).access_token,
        });
    }
};
